import { render } from "./AppContentSkeleton.vue?vue&type=template&id=21d8c30b"
import script from "./AppContentSkeleton.vue?vue&type=script&lang=js"
export * from "./AppContentSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__